module.exports = __webpack_public_path__ + "img/dhanesh_img.8ea63127.png";